const STORAGE_KEY = "sidebar:collapsed";

export default function registerSidebar(Alpine) {
  Alpine.store("sidebar", {
    collapsed: false,
    hoverExpanded: false,
    mobileOpen: false,

    init() {
      this.collapsed = localStorage.getItem(STORAGE_KEY) === "true";
    },

    get expanded() {
      return !this.collapsed || this.hoverExpanded;
    },

    toggle() {
      this.collapsed = !this.collapsed;
      this.hoverExpanded = false;
      localStorage.setItem(STORAGE_KEY, String(this.collapsed));
    },

    hoverOn() {
      if (this.collapsed) this.hoverExpanded = true;
    },

    hoverOff() {
      this.hoverExpanded = false;
    },

    toggleMobile() {
      this.mobileOpen = !this.mobileOpen;
    },

    closeMobile() {
      if (!this.mobileOpen) return;
      this.mobileOpen = false;
      window.dispatchEvent(new CustomEvent("sidebar-closed"));
    }
  });

  Alpine.data("sidebar", () => ({
    init() {
      this._onResize = () => this.updateInert();
      this._onNavigate = () => this.$store.sidebar.closeMobile();
      window.addEventListener("resize", this._onResize);
      document.addEventListener("turbo:visit", this._onNavigate);
      this.updateInert();
    },

    destroy() {
      window.removeEventListener("resize", this._onResize);
      document.removeEventListener("turbo:visit", this._onNavigate);
    },

    updateInert() {
      const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
      this.$el.inert = !isDesktop && !this.$store.sidebar.mobileOpen;
    }
  }));
}
